<template>
      <div id="overview">
            <section class="section intro-hero animate__animated animate__fadeIn">
                  <BackButton link="/welcome-back-current" />
                  <div class="grid-container max">
                        <div class="intro-hero-grid">
                              <div class="intro-hero-left">
                                    <h1>Welcome back, {{ firstName }}</h1>
                              </div>
                              <div class="intro-hero-right">
                                    <p class="overview-label">This year, the Open Enrollment selection period is:</p>
                                    <a href="https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20261019%2F20261107&details=This%20year%2C%20the%20Open%20Enrollment%20selection%20period%20is%20October%2019%2C%202026%20-%0ANovember%206%2C%202026.%20&text=Anthem%20Open%20Enrollment" class="overview-date" target="_blank" @click="track('Link', 'Add To Calendar - Overview Current')">October 19 &ndash; November 6, 2026</a>
                                    <p class="overview-estimate">The estimated length of your experience on this site will be: <span>6 minutes</span></p>
                              </div>
                        </div>
                  </div>
                  <div class="intro-hero-btn-wrap">
                        <router-link to="/checklist-current" class="intro-hero-btn"><span>Next</span></router-link>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPOverview",
            data (){
                  return{
                        firstName: this.$store.state.firstName,
                  }
            },
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#overview {
      .intro-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 100px 0;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .intro-hero-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  gap: 40px;
            }

            .intro-hero-left {
                  flex: 1 1 480px;
                  max-width: 760px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(4.25rem, 6.5vw, 5.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .intro-hero-right {
                  flex: 1 1 320px;
                  max-width: 570px;

                  .overview-label {
                        color: #012E58;
                        font-size: 1.25rem;
                        font-weight: 500;
                        line-height: 1.3;
                        margin-bottom: 4px;
                  }

                  .overview-date {
                        display: block;
                        color: #1355E9 !important;
                        font-size: 2rem;
                        font-weight: 500;
                        line-height: 1.2;
                        margin-bottom: 20px;
                        text-decoration: none;

                        &:hover {
                              text-decoration: underline;
                        }
                  }

                  .overview-estimate {
                        color: #12130f;
                        font-size: 1rem;
                        line-height: 1.5;
                        margin-bottom: 0;

                        span {
                              color: #1355E9;
                              font-weight: 700;
                        }
                  }
            }

            .intro-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .intro-hero-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 100px 24px;
                  justify-content: flex-start;

                  .back-btn {
                        left: 2rem;
                  }

                  .intro-hero-grid {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0;
                  }

                  .intro-hero-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 11vw, 5.25rem) !important;
                        }
                  }

                  .intro-hero-right {
                        flex: 0 0 auto;
                        width: 100%;
                        max-width: 100%;
                        margin-top: 48px;

                        .overview-date {
                              font-size: 1.75rem;
                        }
                  }
            }
      }
}
</style>
